export default "/images/vendor/flag-icon-css/flags/1x1/pa.svg?69b3b90501ccfc42beffe5f0fd531d4e";